import IntersectionHydrator from '@netc/intersection-hydrator';
import type { ReactNode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { registrations } from '../registrations';

// React 19 removed ReactDOM.hydrate; provide a compatibility shim for legacy hydrators.
const reactDomCompat = require('react-dom') as {
	hydrate?: (element: ReactNode, container: Element | Document) => void;
};

if (typeof reactDomCompat.hydrate !== 'function') {
	reactDomCompat.hydrate = (element, container) => {
		hydrateRoot(container, element);
	};
}

new IntersectionHydrator(registrations);
